import { ReactElement } from 'react';
import { tile } from '@interfaces/interfaces';
import { Field, useFormikContext } from 'formik';
import { TileRadioAccessible, Alert } from '@components';
import gridStyles from '@pages/forms/Grid.module.scss';
import { iNominationFormValues } from '@services/NominationService';
import NominationStep4AlertContent1 from '@components/Content/AlertContent/NominationStep4AlertContent1';
import styles from './NominationStep4.module.scss';
import InfoIcon from '../../../../images/info.svg';

function NominationStep4(): ReactElement {
  const YesValue = (): ReactElement => (
    <>
      <div>Yes</div>
    </>
  );

  const NoValue = (): ReactElement => (
    <>
      <div>No</div>
    </>
  );

  const TILE_DATA: tile[] = [
    {
      body: <YesValue />,
      value: 'true',
    },
    {
      body: <NoValue />,
      value: 'false',
    },
  ];
  const { values }: { values: iNominationFormValues; } = useFormikContext<iNominationFormValues>();
  return (
    <>
      <div className={gridStyles.form}>
        <span className="vfH2">Are you the person named on the fine?</span>
        <div className={gridStyles.gridColFull}>
          <div className={styles.col}>
            <Field
              name="isThePersonNamed"
              title=""
              component={TileRadioAccessible}
              tileData={TILE_DATA}
              orientationRow
              isMandatory
            />
            {values.isThePersonNamed === 'false' && (
              <Alert
                message={<NominationStep4AlertContent1 />}
                theme="error"
                title="Only the person named on the fine can nominate the driver"
                icon={InfoIcon}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default NominationStep4;
